import React from "react";
import JobTabs from "./JobTabs";
import JobCard from "./JobCard";
import JobDetailsPanel from "./JobDetailsPanel";

export default function WorkspaceSection(props) {
  const {
    jobs,
    activeTab,
    setActiveTab,
    selectedJob,
    setSelectedJob,
    clips,
    clipsLoading,
    handleSelectJob,
    handleRetry,
    renderTimeline,
    getJobStateUI,
    setPreviewClip,
  } = props;

  const queuedJobs = jobs.filter(
    (j) => j.status !== "done" && j.status !== "failed",
  );
  const completedJobs = jobs.filter((j) => j.status === "done");
  const failedJobs = jobs.filter((j) => j.status === "failed");

  const jobsToShow =
    activeTab === "queue"
      ? queuedJobs
      : activeTab === "completed"
        ? completedJobs
        : failedJobs;

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      {/* LEFT */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <JobTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedJob={setSelectedJob}
          counts={{
            queue: queuedJobs.length,
            completed: completedJobs.length,
            failed: failedJobs.length,
          }}
        />

        <div className="space-y-3">
          {jobsToShow.map((job) => (
            <JobCard
              key={job.id}
              job={job}
              isActive={selectedJob?.id === job.id}
              onClick={handleSelectJob}
            />
          ))}
        </div>
      </div>

      {/* RIGHT */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <JobDetailsPanel
          selectedJob={selectedJob}
          clips={clips}
          clipsLoading={clipsLoading}
          handleRetry={handleRetry}
          renderTimeline={renderTimeline}
          getJobStateUI={getJobStateUI}
          setPreviewClip={setPreviewClip}
        />
      </div>
    </div>
  );
}
